import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const uploadProfilePicture = createAsyncThunk<string, { picture: File }, { extra: Partial<Dependencies> }>(
  "users/uploadProfilePicture",
  async ({ picture }: { picture: File }, { extra: { sharedRepository } }) => {
    return sharedRepository!.uploadProfilePicture(picture);
  },
);

export const uploadProfilePicturePublic = createAsyncThunk<string, { picture: File }, { extra: Partial<Dependencies> }>(
  "users/uploadProfilePicturePublic",
  async ({ picture }: { picture: File }, { extra: { publicRepository } }) => {
    return publicRepository!.uploadProfilePicture(picture);
  },
);

export const resetUploadProfilePicture = createAction("users/resetUploadProfilePicture");
